// 1) Polyfills for modern browsers

// (IE11 polyfill removed) 

// 2) Global CSS imports
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './index.css';

// 3) Bootstrap JS bundle
import 'bootstrap/dist/js/bootstrap.bundle.min';

// 4) i18n configuration
import './i18n';

// 5) React & routing
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// 6) Performance log (debug)
console.log('⌛️ App bootstrap at', performance.now());

// 7) Mount the app
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

console.log('✅ App rendered at', performance.now());